import { populateNotifications as populate } from '../utilities/constants';

export const eventNames = [
  /* ---------------------- BULK INVOICES ------------------------ */
  ...populate('BULK_MARK_AS_PAID'),
  ...populate('BULK_UPDATE_INVOICE_DATES'),

  /* ---------------------- BULK ORDERS ------------------------ */
  ...populate('BULK_UPDATE_ORDERS'),

  /* ---------------------- BULK PRODUCTS ------------------------ */
  ...populate('BULK_UPDATE_PRODUCTS'),
  ...populate('BULK_DELETE_PRODUCTS'),

  /* ---------------------- BULK RETAILERS ------------------------ */
  ...populate('BULK_UPDATE_RETAILERS'),
  ...populate('BULK_EMAIL_RETAILERS'),
  ...populate('BULK_DELETE_RETAILERS'),

  /* ---------------------- CATEGORY ------------------------ */
  ...populate('CREATE_CATEGORY'),
  ...populate('UPDATE_CATEGORY'),
  ...populate('DELETE_CATEGORY'),

  ...populate('UPDATE_CATEGORY_SORT'),

  /* ---------------------- CONNECTION REQUESTS ------------------------ */

  ...populate('UPDATE_CONNECTION'),

  /* --- CREDIT NOTES ------------------------ */
  ...populate('CREATE_CREDIT_NOTE'),
  ...populate('UPDATE_CREDIT_NOTE'),
  ...populate('CANCEL_CREDIT_NOTE'),
  ...populate('UNRESERVE_CREDIT_NOTE'),
  ...populate('EMAIL_CREDIT_NOTE'),
  ...populate('UPDATE_CREDIT_NOTE_PROPERTIES'),

  /* ---------------------- EMAILS ------------------------ */
  ...populate('SEND_WELCOME_EMAIL'),

  /* ---------------------- EXPORT ------------------------ */
  ...populate('QUEUE_EXPORT'),

  /* ---------------------- FILTER ------------------------ */
  ...populate('FETCH_FILTER'),
  ...populate('CREATE_FILTER'),
  ...populate('UPDATE_FILTER'),
  ...populate('DELETE_FILTER'),
  ...populate('SHARE_FILTER'),

  /* ---------------------- FREIGHT GROUPS------------------------ */
  ...populate('CREATE_FREIGHT_GROUP'),
  ...populate('UPDATE_FREIGHT_GROUP'),
  ...populate('DELETE_FREIGHT_GROUP'),
  ...populate('NO_FREIGHT_GROUP_NAME'),

  ...populate('CREATE_FREIGHT_RETAILER'),
  ...populate('DELETE_FREIGHT_RETAILER'),

  /* ---------------------- IMAGES ------------------------ */
  ...populate('UPLOAD_IMAGE'),
  ...populate('REMOVE_IMAGE'),

  /* ---------------------- IMAGES ------------------------ */
  ...populate('IMPORT_PRODUCTS'),

  /* ---------------------- INSIGHTS ---------------------- */

  ...populate('REQUEST_DASHBOARD'),

  /* ---------------------- INTEGRATIONS ------------------------ */
  ...populate('DISCONNECT_INTEGRATION'),
  ...populate('SYNC_INTEGRATION'),

  /* ---------------------- INVITATIONS ------------------------ */
  ...populate('INVITE_PURCHASER'),
  ...populate('CREATE_INVITE'),
  ...populate('SEND_INVITE'),
  ...populate('SEND_BULK_INVITES'),
  ...populate('SUPPLIER_USER_INVITE'),

  /* ---------------------- INVOICE ------------------------ */
  ...populate('UPDATE_INVOICE_PAYMENT'),
  ...populate('SEND_INVOICE_EMAIL'),
  ...populate('PAY_INVOICE'),
  ...populate('UPDATE_INVOICE'),
  ...populate('REFUND_INVOICE'),

  /* ---------------------- ORDER ------------------------ */
  ...populate('UPDATE_ORDER'),
  ...populate('CREATE_ORDER'),
  ...populate('UPDATE_ORDER_TOTALS'),
  ...populate('UPDATE_ORDER_DATES'),
  ...populate('GET_INVOICE_DATES'),
  ...populate('SEND_ORDER_EMAIL'),
  ...populate('REFUND_INVOICE'),
  ...populate('SYNC_ORDER_INVOICE'),
  ...populate('CANCEL_ORDER'),
  ...populate('UPDATE_ORDER_PROPERTIES'),
  ...populate('UPDATE_DELIVERY_DATE'),
  ...populate('ORDERS_BULK_INVOICE'),
  ...populate('GENERATE_ORDER_INVOICE'),
  ...populate('CALCULATE_DELIVERY'),
  ...populate('ACCEPT_FILTER'),

  /* ---------------------- PAYMENT METHOD ------------------------ */
  ...populate('CREATE_PAYMENT_METHOD'),
  ...populate('DELETE_PAYMENT_METHOD'),
  ...populate('CREATE_PAYMENT'),
  ...populate('DELETE_PAYMENT_METHOD'),
  ...populate('REMOVE_DEFAULT_PAYMENT_METHOD'),

  /* ---------------------- PAYMENT METHOD LINK ------------------------ */
  ...populate('CREATE_PAYMENT_METHOD_LINK'),

  /* ---------------------- PERMISSIONS------------------------ */
  ...populate('PERMISSION'),
  ...populate('UPDATE_PERMISSIONS'),

  /* ---------------------- PRICING GROUPS ------------------------ */
  ...populate('CREATE_PRICING_GROUP'),
  ...populate('UPDATE_PRICING_GROUP'),
  ...populate('DELETE_PRICING_GROUP'),

  ...populate('CREATE_PRICING_RETAILER'),
  ...populate('DELETE_PRICING_RETAILER'),

  ...populate('UPDATE_PRICING_PRICES'),

  /* ---------------------- PRODUCT ------------------------ */
  ...populate('CREATE_PRODUCT'),
  ...populate('UPDATE_PRODUCT'),
  ...populate('DELETE_PRODUCT'),

  ...populate('UPDATE_PRODUCT_SORT'),
  ...populate('CREATE_VARIANT'),
  ...populate('UPDATE_VARIANT'),

  /* ---------------------- PROPERTY ------------------------ */
  ...populate('CREATE_PROPERTY'),
  ...populate('UPDATE_PROPERTY'),
  ...populate('DELETE_PROPERTY'),

  /* ---------------------- PURCHASER ------------------------ */
  ...populate('CREATE_PURCHASER'),
  ...populate('TOGGLE_STOP_CREDIT_STATUS'),
  ...populate('UPDATE_PAYMENT_METHOD_TYPE'),
  ...populate('UPDATE_PURCHASER_DETAILS'),
  ...populate('DEACTIVATE_PURCHASER'),
  ...populate('ACTIVATE_PURCHASER'),
  ...populate('ARCHIVE_PURCHASER'),
  ...populate('ARCHIVE_FEEDBACK'),
  ...populate('RESTORE_PURCHASER'),
  ...populate('STOP_CREDIT_PURCHASER'),
  ...populate('ALLOW_CREDIT_PURCHASER'),
  ...populate('UPDATE_PURCHASER_PROPERTIES'),

  /* ---------------------- PURCHASER ------------------------ */
  ...populate('RESTORE_PURCHASER_SCHEDULE'),
  ...populate('CANCEL_PURCHASER_SCHEDULE'),

  /* ---------------------- RETAILER ------------------------ */
  ...populate('UPDATE_RETAILER_REF'),
  ...populate('REMOVE_RETAILER_USER'),

  /* ---------------------- SCHEDULE ------------------------ */
  ...populate('CREATE_SCHEDULE'),
  ...populate('UPDATE_SCHEDULE'),
  ...populate('DELETE_SCHEDULE'),
  ...populate('INVALID_SCHEDULE_CUT_OFF'),
  ...populate('NO_SCHEDULE_START_DATE'),
  ...populate('NO_SCHEDULE_NAME'),

  /* ---------------------- SETTINGS ------------------------ */
  ...populate('UPLOAD_IMAGE'),

  /* ---------------------- STANDING ORDERS ------------------------ */

  ...populate('UPDATE_STANDING_ORDERS'),

  /* ---------------------- SUPPLIER ------------------------ */
  ...populate('UPDATE_SUPPLIER'),

  /* ---------------------- USERS ------------------------ */
  ...populate('CREATE_USER'),
  ...populate('CREATE_RETAILER_OWNER'),

  /* ---------------------- VENUES ------------------------ */
  ...populate('CREATE_CUSTOMER'),

  /* ---------------------- VISIBILITY GROUP ------------------------ */
  ...populate('CREATE_VISIBILITY_GROUP'),
  ...populate('UPDATE_VISIBILITY_GROUP'),

  ...populate('BULK_CREATE_VISIBILITY_PRODUCT'),
  ...populate('BULK_DELETE_VISIBILITY_PRODUCT'),

  /* ---------------------- WEBSOCKETS ------------------------ */
  ...populate('WEBSOCKET_MESSAGE'),

  /* ---------------------- PROFILE ------------------------ */
  ...populate('CREATE_PROFILE'),
  ...populate('UPDATE_PROFILE'),
  ...populate('DELETE_PROFILE'),
  ...populate('BULK_APPLY_PROFILE'),

  /* ---------------------- PROMOTION ------------------------ */
  ...populate('CREATE_PROMOTION'),
  ...populate('UPDATE_PROMOTION'),
  ...populate('DELETE_PROMOTION'),

  ...populate('SEND_REFERRAL'),

  ...populate('UPGRADE_SUBSCRIPTION'),
  ...populate('UPDATE_SUPPLIER_SERVICE_AREA'),
  ...populate('DELETE_SUPPLIER_SERVICE_AREA'),

  /* --- BRANDING PAGE ------------------------ */
  ...populate('BRANDING_FIELD'),

  ...populate('INTEGRATION_CONNECT'),

  /* --- CHAT IMAGES ------------------------- */
  ...populate('IMAGE_UPLOAD'),
  'NOTIFY_COPIED_TO_CLIPBOARD',
] as const;

type EventName = (typeof eventNames)[number];

const events: { [K in EventName]: K } = Object.fromEntries(
  eventNames.map(event => [event, event])
) as { [K in EventName]: K };

export default events;
